
import { VolunteerPointViewRecord} from './volunteer-point-record'


export class VolunteerTaskPointRecord {
    id: number;
    volunteerPointId: string;
    taskId: number;
    scoutId: string;
    commonName: string | null = null;
    revisionId?: number;
    qrValidationRequired?: boolean;
    photoValidationRequired?: boolean;
    computeFixValidationRequired?: boolean;
    callIntervalSecs?: number;
    callsPlacedCnt?: number;
    targetCallCnt?: number;
    targetCallDurationSecs?: number;
    dialNumber?: string;
    lastValidRutId?: number;
    status?: number;
};


export class VolunteerTaskPointViewRecord extends VolunteerTaskPointRecord {
    volunteerPointId: string;
    scoutId: string | null;
    taskId: number;
    statusName?: string;

    buildingId: string | null = null;
    pointId: string | null = null;
    volunteerId: string | null = null;
    modifiedAt: Date | null = null;
    modifiedBy: string | null = null;
    deleted: boolean = false;

    buildingName: string | null = null;
    volunteerName: string | null = null;
    modifiedByName : string | null = null;
    modifiedAtText: string | null = null;
    pathId: string | null = null;
    latitude: number | null = null;
    longitude: number | null = null;
    civicAddress: string | null = null;
    floorAndDescript: string | null = null;
    locationDescription: string | null = null;
    pointIdQr: string | null = null;
    lastCallTime?: string | null;
    lastCallDuration?: number | null;
};
